import type { ComponentProps } from "react"
import { Tabs as TabsBase } from "@/v2-ui/tabs/base/TabsBase"
import cn from "../utils/utils.cn"

export type TabsProps = ComponentProps<typeof TabsBase>

function Tabs(props: TabsProps) {
  const { orientation, ...tabsBaseProps } = props
  return (
    <TabsBase
      orientation={orientation}
      className={cn({
        flex: orientation === "vertical",
      })}
      {...tabsBaseProps}
    />
  )
}

export default Tabs
